//
// Below helper get rids of inline styling – if it has a certain integer value – and replaces it with
// an abbreviated className. For example, '{width: 50px}'' is replaced with '.w50'
// See the corresponding classNames in trim_pixel_styles.less
//

const MIN = 0
const SIZE_MAX = 1000
const BOX_SIZE_MAX = 500
const POSITION_MAX = 500
const GAP_MAX = 50
const BORDER_RADIUS_MAX = 50

export const trimPixelStyles = ({
	styles,
	classNames,

	width,
	minWidth,
	maxWidth,

	height,
	minHeight,
	maxHeight,

	gap,
	borderRadius,

	marginLeft,
	marginRight,
	marginTop,
	marginBottom,

	paddingLeft,
	paddingRight,
	paddingTop,
	paddingBottom,

	top,
	right,
	bottom,
	left,
}) => {
	const deleteStyle = (style, value, prefix, maximum) => {
		const present = value && _.inRange(value, MIN, maximum + 1)
		if (!present) return

		const className = `${prefix}${_.floor(value)}`

		delete styles[style]
		classNames.push(className)
	}

	deleteStyle('width', width, 'w', SIZE_MAX)
	deleteStyle('minWidth', minWidth, 'minw', SIZE_MAX)
	deleteStyle('maxWidth', maxWidth, 'maxw', SIZE_MAX)

	deleteStyle('height', height, 'h', SIZE_MAX)
	deleteStyle('minHeight', minHeight, 'minh', SIZE_MAX)
	deleteStyle('maxHeight', maxHeight, 'maxh', SIZE_MAX)

	deleteStyle('gap', gap, 'g', GAP_MAX)
	deleteStyle('borderRadius', borderRadius, 'br', BORDER_RADIUS_MAX)

	deleteStyle('marginLeft', marginLeft, 'ml', BOX_SIZE_MAX)
	deleteStyle('marginRight', marginRight, 'mr', BOX_SIZE_MAX)
	deleteStyle('marginTop', marginTop, 'mt', BOX_SIZE_MAX)
	deleteStyle('marginBottom', marginBottom, 'mb', BOX_SIZE_MAX)

	deleteStyle('paddingLeft', paddingLeft, 'pl', BOX_SIZE_MAX)
	deleteStyle('paddingRight', paddingRight, 'pr', BOX_SIZE_MAX)
	deleteStyle('paddingTop', paddingTop, 'pt', BOX_SIZE_MAX)
	deleteStyle('paddingBottom', paddingBottom, 'pb', BOX_SIZE_MAX)

	deleteStyle('top', top, 't', POSITION_MAX)
	deleteStyle('right', right, 'r', POSITION_MAX)
	deleteStyle('bottom', bottom, 'b', POSITION_MAX)
	deleteStyle('left', left, 'l', POSITION_MAX)

	return {styles, classNames}
}
